import { getYear, isValid, parseISO, startOfDay } from "date-fns";
import { isLoanPortfolio } from "web_myplann/Calculators/Utils/isLoanPortfolio";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { isPositiveNumber } from "web_myplann/Shared/Utils/isPositiveNumber";
import type { CalculatorPrefill } from "web_myplann/Utils/WebViewModel";

export const buildRefinancingPrefill = (
	portfolio: PortfolioDetailResponseDTO,
): CalculatorPrefill | null => {
	if (!isLoanPortfolio(portfolio)) {
		return null;
	}
	const { data } = portfolio;

	const installment = data?.installment;
	const interestRate = data?.interestRate;
	const maturityMonths = portfolio.maturityLengthMonths;
	const signedAt = portfolio.signedAt ? parseISO(portfolio.signedAt) : null;

	const prefill: CalculatorPrefill = {
		contractId: portfolio.id,
		contractNumber: portfolio.contractNumber ?? undefined,
		producer: portfolio.producer ?? undefined,
	};

	if (isPositiveNumber(installment)) {
		prefill.originMonthlyPayment = installment;
	}

	if (isPositiveNumber(interestRate)) {
		prefill.originInterest = interestRate;
	}

	if (isPositiveNumber(maturityMonths)) {
		const originMortgageYears = Math.floor(maturityMonths / 12);
		if (originMortgageYears >= 1) {
			prefill.originMortgageYears = originMortgageYears;
		}
	}

	if (signedAt && isValid(signedAt)) {
		const signedYear = getYear(startOfDay(signedAt));
		prefill.repaymentPeriod = Math.max(
			1,
			new Date().getFullYear() - signedYear,
		);
	}

	return prefill;
};
